import React from 'react';
import RootLayout from 'common/layout/root-layout';
import { AccountPlatformFeatureProvider } from 'components/account-platform-features/context';
import { useUser } from 'contexts/user';
import NavigationMenu from './NavigationMenu';
import { Link, Route, Switch } from 'react-router-dom';
import ChargingPolicies from './ChargingPolicies';
import CustomerGroups from './CustomerGroups';
import ChargingGroups from './ChargingGroups';
import Breadcrumbs from 'components/Breadcrumbs';
import { useTranslation } from 'react-i18next';
import { ChargingPolicyForm } from './ChargingPolicies/form';

export default function GroupsAndPolicies() {
  const { t } = useTranslation();
  const { user } = useUser();

  return (
    <RootLayout>
      <AccountPlatformFeatureProvider accountId={user?.accountId}>
        <Breadcrumbs
          path={[<Link to="/charging-stations">Charging Stations</Link>]}
          active={t('policiesAndGroups.title', 'Policies & Groups')}
        />

        <NavigationMenu />

        <Switch>
          <Route
            path="/charging-stations/policies-and-groups/charging-policies/new"
            component={() => <ChargingPolicyForm />}
          />
          <Route
            path="/charging-stations/policies-and-groups/charging-policies"
            component={() => <ChargingPolicies />}
          />
          <Route
            exact
            path="/charging-stations/policies-and-groups/customer-groups"
            component={() => <CustomerGroups />}
          />
          <Route
            exact
            path="/charging-stations/policies-and-groups/charging-groups"
            component={() => <ChargingGroups />}
          />
        </Switch>
      </AccountPlatformFeatureProvider>
    </RootLayout>
  );
}
